import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ShowPollResultComponent } from '../show-poll-result/show-poll-result.component';

@Component({
  selector: 'app-vote-result',
  templateUrl: './vote-result.component.html',
  styleUrls: ['./vote-result.component.scss']
})
export class VoteResultComponent implements OnInit {
  testData = [{Name:'test',Type:'Poll',Date:'12/10/2020',Result:'Option 1'},
  {Name:'test',Type:'Poll',Date:'11/10/2020',Result:'Option 2'},
  {Name:'test',Type:'Quiz',Date:'9/10/2020',Result:'Option 1'},
  {Name:'test',Type:'Poll',Date:'8/10/2020',Result:'Option 4'},
  {Name:'test',Type:'Quiz',Date:'7/10/2020',Result:'Option 2'},
];
  animal: string;
  name: string;
  screenwidth =null;
  dialogwidth = null;

  constructor(private dialog: MatDialog) {
    
  }

  ngOnInit(): void {
    this.screenwidth = screen.width;
    if(this.screenwidth < 500){
      this.dialogwidth = '90%';
    }else{
      this.dialogwidth = '50%';
    }
    console.log(this.screenwidth);
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ShowPollResultComponent, {
      width: this.dialogwidth,
      data: {name: this.name, animal: this.animal}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.animal = result;
    });
  }
}
